import { ConfigContext } from './contexts/configContext';
import { ViewContext } from './contexts/viewContext';
import Calculator from './components/Calculator';
import Screening from './components/Screening';
import Admin from './components/Admin';

function App({ dataConfig, view }) {
	return (
		<ConfigContext.Provider value={dataConfig}>
			<ViewContext.Provider value={view}>
				{view && view.page === 'calculator' && <Calculator />}
				{view && view.page === 'screening' && <Screening />}
				{view && view.page === 'admin' && <Admin />}
			</ViewContext.Provider>
		</ConfigContext.Provider>
	);
}

export default App;
